"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var base = "";

var urlUserValidate = exports.urlUserValidate = base + "/api/user/validate";

var userValidate = exports.userValidate = function userValidate(axios, urlUserValidate, vals) {
  return axios.post("" + urlUserValidate, vals);
};